import cx from 'classnames';
import Tooltip from 'rc-tooltip';

import Icon from '../../../../../../common/general/Icon';
import InvestigatorFieldIcon from '../../../shared/EncounterDescNew/InvestigatorFields/InvestigatorFieldIcon/InvestigatorFieldIcon';

export default function CustomColumnHeader({ title, showSorting = true, investigatorField = false }) {
  const isOneLine = title.split(' ')?.length === 1;
  const trigger = isOneLine ? title?.length > 18 : title?.length > 28;
  return (
    <>
      {investigatorField && <InvestigatorFieldIcon />}
      {trigger ? (
        <Tooltip
          destroyTooltipOnHide={false}
          overlayClassName="eds-rc-tooltip logs-table-tooltip over-modal"
          placement="top"
          overlay={title}
        >
          <div className="custom-sort-header">
            <div className={cx('title', { 'one-line': title.split(' ')?.length === 1 })}>{title}</div>
            {showSorting && (
              <div className="icons">
                <Icon>expand_less</Icon>
                <Icon>expand_more</Icon>
              </div>
            )}
          </div>
        </Tooltip>
      ) : (
        <div className="custom-sort-header">
          <div className={cx('title', { 'one-line': title.split(' ')?.length === 1 })}>{title}</div>
          {showSorting && (
            <div className="icons">
              <Icon>expand_less</Icon>
              <Icon>expand_more</Icon>
            </div>
          )}
        </div>
      )}
    </>
  );
}
